import { render } from "./EspecialidadesPage.vue?vue&type=template&id=314ef37c"
import script from "./EspecialidadesPage.vue?vue&type=script&lang=js"
export * from "./EspecialidadesPage.vue?vue&type=script&lang=js"

import "./EspecialidadesPage.vue?vue&type=style&index=0&id=314ef37c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__